var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#">\n  <div class="js-avatar">\n\n  </div>\n  <div class="js-user-details">\n    <h4>'+
((__t=( name ))==null?'':_.escape(__t))+
'</h4>\n  </div>\n</a>\n';
}
return __p;
};
